import { render, staticRenderFns } from "./gravies.vue?vue&type=template&id=3f71e848"
import script from "./gravies.vue?vue&type=script&lang=js"
export * from "./gravies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports